import type { SleepRecord } from './types'

const clockMinutes = (at: string, zone: string) => {
  const parts = new Intl.DateTimeFormat('en-GB', { timeZone: zone, hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(at))
  return Number(parts.find(p => p.type === 'hour')?.value) * 60 + Number(parts.find(p => p.type === 'minute')?.value)
}
const distance = (a: number, b: number) => Math.min(Math.abs(a - b), 1440 - Math.abs(a - b))

/** Product reference rule v1; not an Apple score or clinical instrument. */
export function sleepScore(record: SleepRecord, history: SleepRecord[], targetMinutes = 480) {
  if (!Number.isFinite(record.durationMinutes) || record.durationMinutes <= 0 || !Number.isFinite(targetMinutes) || targetMinutes <= 0) return null
  const byDay = new Map<string, SleepRecord>()
  const day = Date.parse(record.wakeLocalDay)
  for (const item of history) {
    const age = (day - Date.parse(item.wakeLocalDay)) / 86400000
    if (age < 1 || age > 13 || !Number.isFinite(age) || item.wakeTimeZone !== record.wakeTimeZone || Date.parse(item.endAt) >= Date.parse(record.endAt) || item.durationMinutes <= 0) continue
    if (!byDay.has(item.wakeLocalDay) || byDay.get(item.wakeLocalDay)!.durationMinutes < item.durationMinutes) byDay.set(item.wakeLocalDay, item)
  }
  const duration = Math.min(100, record.durationMinutes / targetMinutes * 100)
  const previous = [...byDay.values()]
  const regularity = previous.length < 3 ? null : Math.max(0, 100 - previous.reduce((sum, item) => sum + (
    distance(clockMinutes(record.startAt, record.wakeTimeZone), clockMinutes(item.startAt, item.wakeTimeZone)) +
    distance(clockMinutes(record.endAt, record.wakeTimeZone), clockMinutes(item.endAt, item.wakeTimeZone))
  ) / 2, 0) / previous.length / 180 * 100)
  const awake = record.details?.awakeMinutes
  const continuity = awake === undefined || !Number.isFinite(awake) || awake < 0 ? null : record.durationMinutes / (record.durationMinutes + awake) * 100
  const weight = 50 + (regularity === null ? 0 : 30) + (continuity === null ? 0 : 20)
  return { value: Math.round((duration * 50 + (regularity ?? 0) * 30 + (continuity ?? 0) * 20) / weight), duration: Math.round(duration), regularity: regularity === null ? null : Math.round(regularity), continuity: continuity === null ? null : Math.round(continuity), partial: weight < 100 }
}
